module.exports = __webpack_public_path__ + "static/45-fa35410e545aca59b57d9d44a186eb7b.png";